import { useReducer,  } from "react";
import { getRemotedbUrl } from "./ep";

export const save_domain = (domain,cb) => {
	$.post('/accounts/domain/save',domain,result=>{
		if(cb != undefined) cb(result);
	},'JSON');
}

export const get_available_domains = (account_id,label_id,cb) => {
	get_all_domains(account_id,label_id,domains=>{
		cb(domains.filter(domain=>domain.Accountdomain.status == 1));
	})
}

export const get_all_domains = (account_id,label_id,cb) => {
	let url = "";
	const data = {}
	if (account_id != undefined) {
		data.account_id = account_id;

		url += `/${account_id}`;
		if (label_id != undefined) {
			data.label_id = label_id;
			url += `/${label_id}`;
		}
	}
	$.get(getRemotedbUrl('/accounts/domain/get'),data,response=>{
		cb(response);
	},'JSON')
}


export const delete_domain = (domain_id, cb) => {
	$.post('/accounts/domain/delete', {id:domain_id}, () => {
		if(cb != undefined) cb();
	}, 'JSON');
};

export const set_domain_default = (domain_id) => {
    $.post('/accounts/domain/set_default', {id:domain_id}, () => {
		
	}, 'JSON');
}


export const set_domain_promotion = (domain_id,promotion_id) => {
    $.post('/accounts/domain/set_promotion', {id:domain_id,promotion_id}, () => {
		
	}, 'JSON');
}

export const activate_domain = (domain_id,cb) => {
	$.post('/accounts/domain/activate',{domain_id},result=>{
		if(cb != undefined) cb(result);
	},'JSON');
}

export const disable_domain = (domain_id,cb) => {
	$.post('/accounts/domain/disable',{domain_id},result=>{
		if(cb != undefined) cb(result);
	},'JSON');
}
